var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAlertYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83E\\uDDFE-Bets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D_Race-Card-_Abandoned",
    transform: "translate(-48.000000, -317.000000)",
    fill: "#F88C03",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 307.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.1063397,11.1981982 C58.6717658,10.4566404 57.8690677,10 57,10 C56.1309323,10 55.3281542,10.4566404 54.8936603,11.1981982 L48.3259304,22.4062334 C47.8913565,23.1470223 47.8913565,24.0603032 48.3259304,24.8018018 C48.7605043,25.5433596 49.5632024,26 50.4322701,26 L63.5677299,26 C64.4368777,26 65.2395758,25.5433596 65.6740696,24.8018018 C66.1086435,24.0602441 66.1086435,23.1469632 65.6740696,22.4062334 L59.1063397,11.1981982 Z M57,24.0595935 C56.6209309,24.0595935 56.2785782,23.833974 56.1332133,23.4889901 C55.9878365,23.1432373 56.0683404,22.7458947 56.336424,22.4817553 C56.6053039,22.216847 57.0086038,22.138309 57.35876,22.2815463 C57.7096966,22.4240069 57.9379184,22.7612908 57.9379184,23.1355294 C57.9379184,23.3804089 57.8394365,23.6152739 57.663576,23.7885347 C57.4877156,23.9617975 57.2485509,24.0595935 57,24.0595935 Z M58.324811,14.7850454 L57.9934232,20.3347527 C57.9621592,20.8529974 57.526815,21.2572792 57.00002,21.2572792 C56.473225,21.2572792 56.0378708,20.8529974 56.0066168,20.3347527 L55.675229,14.7850454 C55.6541256,14.4254342 55.7838715,14.0735111 56.0347694,13.8116979 C56.2856613,13.5491159 56.6342568,13.4012656 57.00004,13.4012656 C57.3658232,13.4012656 57.7144187,13.5491159 57.9653106,13.8116979 C58.2162026,14.0735111 58.3459404,14.4254342 58.324851,14.7850454 L58.324811,14.7850454 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertYellow);
export default ForwardRef;